__webpack_require__.p = "/rapoarte/";